import { inject, Injectable } from '@angular/core';
import {
  ProductServoPipelineResultDto,
  PublicServoGarantieApiService,
  PublicServoGarantieContractCreateDto, ServoGarantieVersicherungspraemieCalcDto
} from '@base/backend';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GarantieService {
  private readonly publicServoGarantieApiService = inject(PublicServoGarantieApiService);

  public getPremium(isPremiumSchutzSelected: boolean): Observable<number | null> {
    const dto: ServoGarantieVersicherungspraemieCalcDto = {
      isPremiumSchutzSelected: isPremiumSchutzSelected
    };

    return this.publicServoGarantieApiService.apiPublicServoGarantieContractGarantieVersicherungspraemiePost(dto).pipe(
      map(result => result.versicherungspraemieInEur || null),
      catchError(() => {
        return of(null);
      })
    );
  }

  submitGarantieContract(dto: PublicServoGarantieContractCreateDto): Observable<ProductServoPipelineResultDto> {
    return this.publicServoGarantieApiService
      .apiPublicServoGarantieContractGarantiePost(dto);
  }
}
